import { Virtuoso } from 'react-virtuoso';
import React from 'react';

import LANG_CONST from 'src/helpers/lang/const';
import { number, useScreenDetail } from 'src/helpers';
import { remCss, remFontCss } from 'src/components/mobile/utils';
import { MCText, View } from 'src/components/basic';
import { MediaGroup } from 'src/components/complex';

export const TreatmentsTab = ({ clinic, currency }) => {
  const screen = useScreenDetail();
  if (!clinic?.treatments?.length) {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'white'
        }}
      >
        <MCText
          label={LANG_CONST.text.no_results_yet}
          size={20}
          weight={500}
          textLight
          remFontCss={remFontCss}
        />
      </View>
    );
  }

  let width = screen.innerWidth - remCss(30);

  return (
    <View style={{ flex: 1, padding: remCss(15), backgroundColor: 'white' }}>
      <Virtuoso
        data={clinic.treatments}
        itemContent={(index, item) => (
          <View style={{ gap: remCss(20), marginBottom: remCss(25) }}>
            {item.media && item.media.length > 0 && (
              <div style={{ width }}>
                <MediaGroup
                  images={item.media.map((m) => m.uri)}
                  template={5}
                  length={1}
                  maxImgWidth={remCss(300)}
                  maxImgHeight={remCss(300)}
                />
              </div>
            )}
            <View style={{ gap: remCss(15) }}>
              <View style={{ gap: remCss(10) }}>
                <MCText label={item.name} size={22} textLight remFontCss={remFontCss} />
                <MCText
                  label={item.description}
                  size={20}
                  weight={500}
                  heading
                  remFontCss={remFontCss}
                />
              </View>
              <MCText
                label={item.fee ? number.format(item.fee) + ' ' + currency : ''}
                size={25}
                weight={500}
                primary
                remFontCss={remFontCss}
              />
            </View>
          </View>
        )}
      />
    </View>
  );
};
